import Dexie from 'dexie';
import {
  SegmentRow,
  TabOptionsType
} from '../Pages/SegmentationMapping/segmentation-mapping-constants';

export interface EditRecord {
  id?: number;
  cid: string;
  campaignKey: string;
  batchType: TabOptionsType;
  rowData: SegmentRow;
  timestamp: number;
}

export class DexieDB extends Dexie {
  editRecords!: Dexie.Table<EditRecord, number>;

  constructor() {
    super('DexieDB');
    this.version(1).stores({
      editRecords: '++id, cid, campaignKey, batchType, rowData, timestamp'
    });
  }
}

export const db = new DexieDB();
